<!-- @veltra/icons generated sha256:6f191e3005232311 gen:8 source:src/svg/normal/form-multi-select.svg -->
<script setup lang="ts">
defineOptions({ name: 'FormMultiSelect' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <rect
      width="14"
      height="8"
      x="1"
      y="4"
      fill="none"
      stroke="currentColor"
      stroke-width="1.2"
      rx="1.5"
    />
    <rect width="3" height="4" x="3" y="6" fill="none" stroke="currentColor" rx="1" />
    <rect width="3" height="4" x="7" y="6" fill="none" stroke="currentColor" rx="1" />
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.2"
      d="m11.5 7.5 1 1 1-1"
    />
  </svg>
</template>
